import React from 'react';
import { detectMobile } from '../../../utils/UiHelper';
import { InputSkeleton, SkeletonContainer } from '../styled';

const SearchFieldSkeleton = ({ isLivePage }) => {
    const isMobile = detectMobile();

    return (
        <SkeletonContainer margin={'0'} padding={'0'}>
            <InputSkeleton
                width={isMobile || isLivePage ? '100%' : '72%'}
                radius={isMobile ? '4px' : '8px'}
            />
        </SkeletonContainer>
    );
};

export default SearchFieldSkeleton;
